/**
 * The Schedule view's calendar blocks (piece 29; decision 2920; T2178): a
 * technician's meeting, call or PTO drawn quiet on their row beside the visits.
 */
export const SCHEDULE_CALENDAR_STRINGS = {
  'schedule.event.allDay': 'All day',
  'schedule.event.label': '{subject}, {hours}, on the calendar of {name}',
  'schedule.event.physical': 'Meeting',
  'schedule.event.online': 'Online meeting',
  'schedule.event.phone': 'Call',
  'schedule.event.pto': 'PTO',
} as const;
